import { Button, Flex, Form, Input, Modal, Switch } from 'antd'
import React, { useEffect, useRef, useState } from 'react'
import { useForm } from 'antd/es/form/Form'
import { addRelative } from '../../../../api/customerRelative/customerRelativeApi'

interface Props {
  show: boolean
  modalClose?: () => void
  onSubmitFormModal: (iSsuccess: boolean, errorMessage?: string) => void
}
const RelativeModalAdd: React.FC<Props> = (props) => {
  const { show, modalClose, onSubmitFormModal } = props
  const [title, setTitle] = useState("")
  const [code, setCode] = useState("")
  const [status, setStatus] = useState(0)

  const formRef: any = useRef(null)
  const [form] = useForm()



  const onFormFinish = async () => {
    const result = await addRelative(code, title, status)
    if (result?.status) {
      onSubmitFormModal?.(true, result?.message)
    } else {
      onSubmitFormModal?.(false, result?.message)
    }
  }
  useEffect(() => {
    if (show) {

    } else {
      setTitle("")
      setStatus(0)
      if (form)
        form.resetFields()
    }

  }, [show])

  return (
    <>
      <Modal
        open={show}
        title='Tạo mối quan hệ'
        className='rs-modal w-400 footer-content-end add-relative-modal'
        centered
        footer={
          <Button
            type='primary'
            className='rs-button rs-button--sm'
            onClick={() => formRef?.current.submit()}
          >Lưu</Button>
        }
        onCancel={modalClose}
      >
        <Form
          ref={formRef}
          form={form}
          className='rs-form add-relative-form'
          onFinish={onFormFinish}
          requiredMark={false}
        >
          <Form.Item
            layout='vertical'
            label='Mã mối quan hệ'
            name='code'
            rules={[
              { required: true, message: "Vui lòng nhập Mã mối quan hệ" }
            ]}
          >
            <Input
              placeholder='Mã mối quan hệ'
              className='rs-input rs-input--32'
              value={code}
              maxLength={8}
              onChange={(e) => setCode(e.target.value)}
            />
          </Form.Item>
          <Form.Item
            layout='vertical'
            label='Tên mối quan hệ'
            name='name'
            rules={[
              { required: true, message: "Vui lòng nhập Tên mối quan hệ" }
            ]}
          >
            <Input
              placeholder='Tên mối quan hệ'
              className='rs-input rs-input--32'
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </Form.Item>

          <Form.Item name='status'>
            <Flex className='gap-24px'>
              <span>Sử dụng</span>
              <Switch
                checked={!!status}
                onChange={(checked) => setStatus(checked ? 1 : 0)}
                className="rs-switch"
              />
            </Flex>
          </Form.Item>
        </Form>
      </Modal>
    </>
  )
}

export default RelativeModalAdd
